package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * American Samoa Flag (32x24dp)
 *
 * - ISO Alpha-2: AS
 * - ISO Alpha-3: ASM
 * - ISO Numeric: 016
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.AmericanSamoa: ImageVector by lazy {
    ImageVector.Builder(
        name = "American Samoa:AS:ASM:016:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3547A0)),
                stroke = SolidColor(Color(0xFFE31D1C)),
                strokeLineWidth = 2f
            ) {
                moveTo(0f, -1f)
                horizontalLineTo(-1f)
                verticalLineTo(0f)
                verticalLineTo(11.307f)
                lineTo(-2.848f, 12f)
                lineTo(-1f, 12.693f)
                verticalLineTo(24f)
                verticalLineTo(25f)
                horizontalLineTo(0f)
                horizontalLineTo(32f)
                lineTo(32.351f, 23.064f)
                lineTo(2.848f, 12f)
                lineTo(32.351f, 0.936f)
                lineTo(32f, -1f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF9C3900)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(29.022f, 5.11f)
                curveTo(29.022f, 5.11f, 27.012f, 5.653f, 26.285f, 5.85f)
                curveTo(26.187f, 5.876f, 26f, 5.924f, 26.013f, 5.657f)
                curveTo(25.553f, 5.952f, 24.81f, 6.251f, 24.506f, 6.336f)
                curveTo(24.353f, 6.379f, 24.394f, 6.114f, 24.328f, 6.038f)
                curveTo(24.196f, 6.233f, 23.855f, 6.519f, 23.759f, 6.547f)
                curveTo(22.8f, 6.825f, 22.164f, 7.026f, 21.85f, 7.152f)
                curveTo(21.85f, 7.152f, 21.401f, 7.584f, 21.401f, 7.927f)
                curveTo(21.401f, 8.269f, 21.353f, 8.561f, 21.044f, 8.561f)
                curveTo(20.735f, 8.561f, 20.022f, 9.184f, 20.283f, 9.534f)
                curveTo(20.544f, 9.885f, 21.401f, 9.698f, 21.401f, 9.534f)
                curveTo(21.401f, 9.37f, 22.011f, 9.165f, 22.011f, 9.35f)
                curveTo(22.011f, 9.534f, 21.85f, 9.868f, 21.85f, 9.868f)
                horizontalLineTo(22.524f)
                lineTo(22.011f, 10.133f)
                horizontalLineTo(22.524f)
                lineTo(22.011f, 10.447f)
                horizontalLineTo(22.971f)
                lineTo(22.358f, 10.721f)
                horizontalLineTo(22.784f)
                lineTo(22.524f, 11.081f)
                horizontalLineTo(23.189f)
                curveTo(23.189f, 11.081f, 23.448f, 11.342f, 23.692f, 11.485f)
                curveTo(23.936f, 11.628f, 24.476f, 12.846f, 24.206f, 13.317f)
                curveTo(23.936f, 13.788f, 24.267f, 13.858f, 24.328f, 13.651f)
                curveTo(24.389f, 13.444f, 24.516f, 13.148f, 24.624f, 13.148f)
                curveTo(24.733f, 13.148f, 24.941f, 13.148f, 24.941f, 13.148f)
                lineTo(25.088f, 13.535f)
                lineTo(25.438f, 13.908f)
                curveTo(25.438f, 13.908f, 25.462f, 13.584f, 25.528f, 13.535f)
                curveTo(25.528f, 13.535f, 25.801f, 13.563f, 25.933f, 13.531f)
                curveTo(25.933f, 13.531f, 25.874f, 13.059f, 25.879f, 12.995f)
                curveTo(25.879f, 12.995f, 26.302f, 13.139f, 26.483f, 13.135f)
                curveTo(26.483f, 13.135f, 26.211f, 12.71f, 26.211f, 12.565f)
                curveTo(26.211f, 12.565f, 26.716f, 12.59f, 26.716f, 12.805f)
                lineTo(26.66f, 12.269f)
                curveTo(26.66f, 12.269f, 27.139f, 12.065f, 27.155f, 11.894f)
                lineTo(26.842f, 11.856f)
                curveTo(26.842f, 11.856f, 27.005f, 11.649f, 26.99f, 11.608f)
                lineTo(26.526f, 11.55f)
                curveTo(26.526f, 11.55f, 27.032f, 11.373f, 27.071f, 11.262f)
                curveTo(27.071f, 11.262f, 26.957f, 11.084f, 26.853f, 11.014f)
                lineTo(26.5f, 10.785f)
                curveTo(26.5f, 10.785f, 27.29f, 10.79f, 27.422f, 10.79f)
                curveTo(27.422f, 10.79f, 27.629f, 10.715f, 27.47f, 10.588f)
                curveTo(27.47f, 10.588f, 27.314f, 10.495f, 27.336f, 10.404f)
                curveTo(27.336f, 10.404f, 27.441f, 10.201f, 27.417f, 10.166f)
                curveTo(27.417f, 10.166f, 27.53f, 10.315f, 27.53f, 9.945f)
                curveTo(27.53f, 9.945f, 27.533f, 9.574f, 27.462f, 9.556f)
                curveTo(27.462f, 9.556f, 27.67f, 9.403f, 27.588f, 9.305f)
                curveTo(27.506f, 9.207f, 26.63f, 8.947f, 26.42f, 8.947f)
                lineTo(28.026f, 7.93f)
                curveTo(28.026f, 7.93f, 28.137f, 7.51f, 28.3f, 7.258f)
                curveTo(28.3f, 7.258f, 28.726f, 6.876f, 28.812f, 6.575f)
                curveTo(28.898f, 6.275f, 29.14f, 5.535f, 29.14f, 5.535f)
                verticalLineTo(5.197f)
                lineTo(29.022f, 5.11f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF212121)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(26.211f, 12.565f)
                curveTo(26.232f, 12.566f, 26.252f, 12.567f, 26.276f, 12.569f)
                curveTo(26.542f, 12.591f, 26.688f, 12.658f, 26.712f, 12.77f)
                lineTo(26.724f, 12.87f)
                curveTo(26.724f, 12.835f, 26.72f, 12.802f, 26.712f, 12.77f)
                lineTo(26.66f, 12.269f)
                curveTo(26.979f, 12.133f, 27.144f, 12.008f, 27.155f, 11.894f)
                lineTo(26.916f, 11.865f)
                lineTo(26.893f, 11.895f)
                lineTo(26.878f, 11.86f)
                lineTo(26.842f, 11.856f)
                lineTo(26.864f, 11.827f)
                lineTo(26.85f, 11.793f)
                lineTo(26.887f, 11.797f)
                curveTo(26.964f, 11.694f, 26.998f, 11.631f, 26.99f, 11.608f)
                lineTo(26.666f, 11.567f)
                curveTo(26.629f, 11.581f, 26.59f, 11.595f, 26.548f, 11.609f)
                curveTo(26.548f, 11.609f, 26.536f, 11.546f, 26.541f, 11.545f)
                lineTo(26.535f, 11.486f)
                lineTo(26.658f, 11.502f)
                curveTo(26.911f, 11.406f, 27.049f, 11.326f, 27.071f, 11.262f)
                curveTo(26.995f, 11.143f, 26.922f, 11.06f, 26.853f, 11.014f)
                lineTo(26.599f, 10.849f)
                lineTo(26.499f, 10.848f)
                curveTo(26.499f, 10.848f, 26.512f, 10.785f, 26.519f, 10.785f)
                lineTo(26.535f, 10.731f)
                lineTo(26.618f, 10.785f)
                curveTo(27.073f, 10.788f, 27.341f, 10.79f, 27.422f, 10.79f)
                curveTo(27.56f, 10.74f, 27.576f, 10.673f, 27.47f, 10.588f)
                curveTo(27.366f, 10.526f, 27.321f, 10.465f, 27.336f, 10.404f)
                curveTo(27.37f, 10.339f, 27.394f, 10.286f, 27.407f, 10.247f)
                curveTo(27.393f, 10.236f, 27.378f, 10.221f, 27.365f, 10.204f)
                lineTo(27.417f, 10.166f)
                lineTo(27.471f, 10.13f)
                curveTo(27.485f, 10.15f, 27.489f, 10.174f, 27.485f, 10.205f)
                curveTo(27.515f, 10.187f, 27.53f, 10.101f, 27.53f, 9.945f)
                curveTo(27.531f, 9.78f, 27.522f, 9.667f, 27.5f, 9.607f)
                lineTo(27.462f, 9.556f)
                lineTo(27.478f, 9.494f)
                curveTo(27.492f, 9.498f, 27.505f, 9.504f, 27.516f, 9.513f)
                curveTo(27.611f, 9.43f, 27.635f, 9.361f, 27.588f, 9.305f)
                curveTo(27.516f, 9.219f, 26.83f, 9.008f, 26.523f, 8.958f)
                lineTo(26.455f, 9.001f)
                curveTo(26.455f, 9.001f, 26.426f, 8.947f, 26.437f, 8.937f)
                lineTo(26.42f, 8.884f)
                curveTo(26.444f, 8.884f, 26.474f, 8.886f, 26.509f, 8.891f)
                lineTo(28.026f, 7.93f)
                curveTo(28.1f, 7.65f, 28.191f, 7.426f, 28.3f, 7.258f)
                curveTo(28.584f, 7.003f, 28.755f, 6.776f, 28.812f, 6.575f)
                curveTo(28.87f, 6.375f, 28.979f, 6.029f, 29.14f, 5.535f)
                verticalLineTo(5.197f)
                lineTo(29.022f, 5.11f)
                curveTo(27.682f, 5.472f, 26.77f, 5.718f, 26.285f, 5.85f)
                curveTo(26.187f, 5.876f, 26f, 5.924f, 26.013f, 5.657f)
                curveTo(25.553f, 5.952f, 24.81f, 6.251f, 24.506f, 6.336f)
                curveTo(24.408f, 6.363f, 24.389f, 6.265f, 24.372f, 6.17f)
                curveTo(24.362f, 6.117f, 24.352f, 6.065f, 24.328f, 6.038f)
                curveTo(24.196f, 6.233f, 23.855f, 6.519f, 23.759f, 6.547f)
                curveTo(22.8f, 6.825f, 22.164f, 7.026f, 21.85f, 7.152f)
                curveTo(21.551f, 7.44f, 21.401f, 7.698f, 21.401f, 7.927f)
                curveTo(21.401f, 8.269f, 21.353f, 8.561f, 21.044f, 8.561f)
                curveTo(20.735f, 8.561f, 20.022f, 9.184f, 20.283f, 9.534f)
                curveTo(20.544f, 9.885f, 21.401f, 9.698f, 21.401f, 9.534f)
                curveTo(21.401f, 9.37f, 22.011f, 9.165f, 22.011f, 9.35f)
                curveTo(22.011f, 9.473f, 21.958f, 9.645f, 21.85f, 9.868f)
                horizontalLineTo(22.385f)
                lineTo(22.494f, 9.811f)
                lineTo(22.51f, 9.875f)
                lineTo(22.524f, 9.931f)
                horizontalLineTo(22.401f)
                lineTo(22.011f, 10.133f)
                horizontalLineTo(22.402f)
                lineTo(22.49f, 10.079f)
                lineTo(22.508f, 10.142f)
                lineTo(22.524f, 10.196f)
                horizontalLineTo(22.42f)
                lineTo(22.011f, 10.447f)
                horizontalLineTo(22.815f)
                lineTo(22.945f, 10.389f)
                lineTo(22.959f, 10.453f)
                lineTo(22.971f, 10.511f)
                horizontalLineTo(22.829f)
                lineTo(22.358f, 10.721f)
                horizontalLineTo(22.704f)
                lineTo(22.731f, 10.684f)
                lineTo(22.75f, 10.721f)
                horizontalLineTo(22.784f)
                lineTo(22.764f, 10.747f)
                lineTo(22.784f, 10.784f)
                horizontalLineTo(22.738f)
                lineTo(22.524f, 11.081f)
                horizontalLineTo(23.189f)
                curveTo(23.362f, 11.255f, 23.529f, 11.39f, 23.692f, 11.485f)
                curveTo(23.936f, 11.628f, 24.476f, 12.846f, 24.206f, 13.317f)
                curveTo(23.936f, 13.788f, 24.267f, 13.858f, 24.328f, 13.651f)
                curveTo(24.389f, 13.444f, 24.516f, 13.148f, 24.624f, 13.148f)
                horizontalLineTo(24.941f)
                lineTo(25.088f, 13.535f)
                lineTo(25.438f, 13.908f)
                curveTo(25.438f, 13.908f, 25.462f, 13.584f, 25.528f, 13.535f)
                curveTo(25.71f, 13.553f, 25.845f, 13.552f, 25.933f, 13.531f)
                curveTo(25.93f, 13.508f, 25.928f, 13.486f, 25.925f, 13.466f)
                curveTo(25.901f, 13.274f, 25.885f, 13.139f, 25.858f, 13.055f)
                lineTo(25.879f, 12.995f)
                curveTo(25.879f, 12.995f, 25.943f, 13.009f, 25.943f, 13.017f)
                curveTo(26.192f, 13.098f, 26.372f, 13.137f, 26.483f, 13.135f)
                curveTo(26.336f, 12.905f, 26.248f, 12.736f, 26.218f, 12.619f)
                curveTo(26.213f, 12.598f, 26.211f, 12.58f, 26.211f, 12.565f)
                close()
                moveTo(26.505f, 11.49f)
                lineTo(26.249f, 11.578f)
                lineTo(26.903f, 11.661f)
                curveTo(26.879f, 11.7f, 26.842f, 11.752f, 26.791f, 11.817f)
                lineTo(26.721f, 11.905f)
                lineTo(27.064f, 11.947f)
                curveTo(27.009f, 12.021f, 26.866f, 12.112f, 26.635f, 12.21f)
                lineTo(26.591f, 12.229f)
                lineTo(26.628f, 12.585f)
                curveTo(26.533f, 12.538f, 26.393f, 12.51f, 26.214f, 12.501f)
                lineTo(26.146f, 12.498f)
                verticalLineTo(12.565f)
                curveTo(26.146f, 12.664f, 26.217f, 12.826f, 26.361f, 13.061f)
                curveTo(26.247f, 13.042f, 26.093f, 13.001f, 25.9f, 12.935f)
                lineTo(25.82f, 12.908f)
                lineTo(25.814f, 12.991f)
                curveTo(25.811f, 13.036f, 25.827f, 13.194f, 25.861f, 13.478f)
                curveTo(25.782f, 13.488f, 25.673f, 13.486f, 25.535f, 13.472f)
                lineTo(25.489f, 13.484f)
                curveTo(25.443f, 13.518f, 25.419f, 13.591f, 25.398f, 13.707f)
                curveTo(25.395f, 13.725f, 25.392f, 13.744f, 25.389f, 13.762f)
                lineTo(25.145f, 13.501f)
                lineTo(24.986f, 13.084f)
                horizontalLineTo(24.624f)
                curveTo(24.485f, 13.084f, 24.357f, 13.326f, 24.266f, 13.634f)
                curveTo(24.249f, 13.691f, 24.207f, 13.71f, 24.186f, 13.691f)
                curveTo(24.146f, 13.655f, 24.156f, 13.533f, 24.262f, 13.348f)
                curveTo(24.397f, 13.114f, 24.36f, 12.712f, 24.203f, 12.258f)
                curveTo(24.068f, 11.868f, 23.866f, 11.514f, 23.725f, 11.431f)
                curveTo(23.567f, 11.339f, 23.404f, 11.207f, 23.236f, 11.036f)
                lineTo(23.216f, 11.017f)
                horizontalLineTo(22.649f)
                lineTo(22.909f, 10.657f)
                horizontalLineTo(22.657f)
                lineTo(23.271f, 10.383f)
                horizontalLineTo(22.238f)
                lineTo(22.75f, 10.069f)
                horizontalLineTo(22.274f)
                lineTo(22.786f, 9.804f)
                horizontalLineTo(21.951f)
                curveTo(22.034f, 9.617f, 22.076f, 9.466f, 22.076f, 9.35f)
                curveTo(22.076f, 9.266f, 22.012f, 9.221f, 21.921f, 9.214f)
                curveTo(21.856f, 9.209f, 21.773f, 9.223f, 21.686f, 9.251f)
                curveTo(21.49f, 9.313f, 21.336f, 9.419f, 21.336f, 9.534f)
                curveTo(21.336f, 9.539f, 21.303f, 9.567f, 21.238f, 9.594f)
                curveTo(21.157f, 9.627f, 21.048f, 9.653f, 20.934f, 9.664f)
                curveTo(20.665f, 9.689f, 20.436f, 9.632f, 20.335f, 9.496f)
                curveTo(20.24f, 9.368f, 20.305f, 9.167f, 20.497f, 8.959f)
                curveTo(20.673f, 8.769f, 20.913f, 8.625f, 21.044f, 8.625f)
                curveTo(21.216f, 8.625f, 21.333f, 8.545f, 21.398f, 8.398f)
                curveTo(21.447f, 8.284f, 21.465f, 8.137f, 21.465f, 7.927f)
                curveTo(21.465f, 7.721f, 21.604f, 7.48f, 21.886f, 7.206f)
                curveTo(22.202f, 7.081f, 22.833f, 6.882f, 23.777f, 6.609f)
                curveTo(23.881f, 6.578f, 24.147f, 6.356f, 24.31f, 6.191f)
                curveTo(24.323f, 6.263f, 24.334f, 6.3f, 24.355f, 6.335f)
                curveTo(24.391f, 6.393f, 24.451f, 6.418f, 24.524f, 6.397f)
                curveTo(24.883f, 6.297f, 25.538f, 6.017f, 25.956f, 5.767f)
                curveTo(25.974f, 5.849f, 26.018f, 5.902f, 26.088f, 5.924f)
                curveTo(26.151f, 5.944f, 26.208f, 5.937f, 26.302f, 5.911f)
                curveTo(26.783f, 5.781f, 27.685f, 5.537f, 29.009f, 5.18f)
                lineTo(29.076f, 5.229f)
                verticalLineTo(5.525f)
                curveTo(28.916f, 6.014f, 28.807f, 6.359f, 28.75f, 6.558f)
                curveTo(28.697f, 6.745f, 28.532f, 6.963f, 28.245f, 7.224f)
                curveTo(28.136f, 7.393f, 28.044f, 7.615f, 27.969f, 7.89f)
                lineTo(26.201f, 9.011f)
                horizontalLineTo(26.42f)
                curveTo(26.621f, 9.011f, 27.474f, 9.269f, 27.538f, 9.346f)
                curveTo(27.561f, 9.373f, 27.536f, 9.422f, 27.423f, 9.505f)
                lineTo(27.315f, 9.585f)
                lineTo(27.435f, 9.615f)
                curveTo(27.44f, 9.626f, 27.446f, 9.646f, 27.451f, 9.673f)
                curveTo(27.461f, 9.733f, 27.466f, 9.825f, 27.465f, 9.945f)
                curveTo(27.465f, 10.04f, 27.459f, 10.107f, 27.45f, 10.141f)
                curveTo(27.45f, 10.141f, 27.36f, 10.188f, 27.357f, 10.188f)
                lineTo(27.357f, 10.187f)
                lineTo(27.357f, 10.187f)
                curveTo(27.356f, 10.195f, 27.353f, 10.207f, 27.348f, 10.223f)
                curveTo(27.335f, 10.259f, 27.312f, 10.31f, 27.272f, 10.39f)
                curveTo(27.251f, 10.483f, 27.31f, 10.566f, 27.433f, 10.64f)
                curveTo(27.492f, 10.688f, 27.491f, 10.696f, 27.411f, 10.726f)
                curveTo(27.31f, 10.726f, 27.006f, 10.724f, 26.5f, 10.721f)
                lineTo(26.281f, 10.719f)
                lineTo(26.817f, 11.067f)
                curveTo(26.871f, 11.103f, 26.931f, 11.168f, 26.994f, 11.262f)
                curveTo(26.974f, 11.28f, 26.938f, 11.305f, 26.885f, 11.333f)
                curveTo(26.798f, 11.38f, 26.671f, 11.432f, 26.505f, 11.49f)
                close()
                moveTo(27.357f, 10.188f)
                lineTo(27.357f, 10.19f)
                lineTo(27.357f, 10.188f)
                lineTo(27.357f, 10.187f)
                lineTo(27.357f, 10.188f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(27.407f, 10.792f)
                curveTo(27.407f, 10.792f, 29.315f, 11.046f, 29.431f, 11.046f)
                curveTo(29.546f, 11.046f, 30.027f, 10.924f, 29.862f, 10.155f)
                curveTo(29.698f, 9.386f, 29.764f, 8.921f, 29.294f, 8.921f)
                curveTo(28.823f, 8.921f, 28.331f, 9.126f, 28.155f, 9.126f)
                curveTo(27.978f, 9.126f, 28.149f, 9.126f, 27.407f, 9.126f)
                curveTo(26.664f, 9.126f, 22.243f, 9.1f, 21.924f, 9.455f)
                curveTo(21.606f, 9.81f, 20.711f, 10.31f, 20.296f, 10.486f)
                curveTo(19.881f, 10.663f, 19.775f, 10.54f, 19.588f, 11.046f)
                curveTo(19.402f, 11.553f, 19.263f, 11.588f, 19.263f, 11.588f)
                lineTo(19.588f, 11.951f)
                horizontalLineTo(20.555f)
                curveTo(20.555f, 11.951f, 21.22f, 11.116f, 22.602f, 11.046f)
                curveTo(23.983f, 10.976f, 27.407f, 10.792f, 27.407f, 10.792f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4D4D4D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(22.602f, 11.046f)
                curveTo(23.523f, 11f, 25.125f, 10.915f, 27.407f, 10.792f)
                curveTo(28.679f, 10.961f, 29.354f, 11.046f, 29.431f, 11.046f)
                curveTo(29.546f, 11.046f, 30.027f, 10.924f, 29.862f, 10.155f)
                curveTo(29.824f, 9.978f, 29.799f, 9.817f, 29.776f, 9.674f)
                curveTo(29.7f, 9.197f, 29.656f, 8.921f, 29.294f, 8.921f)
                curveTo(29.001f, 8.921f, 28.702f, 9f, 28.474f, 9.06f)
                curveTo(28.334f, 9.096f, 28.222f, 9.126f, 28.155f, 9.126f)
                horizontalLineTo(27.407f)
                curveTo(27.368f, 9.126f, 27.32f, 9.126f, 27.264f, 9.126f)
                curveTo(26.22f, 9.124f, 22.226f, 9.119f, 21.924f, 9.455f)
                curveTo(21.606f, 9.81f, 20.711f, 10.31f, 20.296f, 10.486f)
                curveTo(20.19f, 10.531f, 20.104f, 10.557f, 20.032f, 10.578f)
                curveTo(19.821f, 10.641f, 19.727f, 10.669f, 19.588f, 11.046f)
                curveTo(19.464f, 11.384f, 19.355f, 11.564f, 19.263f, 11.588f)
                lineTo(19.588f, 11.951f)
                horizontalLineTo(20.555f)
                curveTo(20.998f, 11.394f, 21.681f, 11.092f, 22.602f, 11.046f)
                close()
                moveTo(20.508f, 11.855f)
                horizontalLineTo(19.632f)
                lineTo(19.407f, 11.605f)
                curveTo(19.498f, 11.512f, 19.584f, 11.338f, 19.679f, 11.079f)
                curveTo(19.716f, 10.98f, 19.749f, 10.907f, 19.781f, 10.853f)
                curveTo(19.838f, 10.755f, 19.884f, 10.724f, 20.007f, 10.686f)
                curveTo(20.01f, 10.685f, 20.019f, 10.682f, 20.033f, 10.678f)
                curveTo(20.066f, 10.668f, 20.123f, 10.651f, 20.148f, 10.643f)
                curveTo(20.212f, 10.623f, 20.271f, 10.601f, 20.334f, 10.574f)
                curveTo(20.88f, 10.342f, 21.71f, 9.838f, 21.997f, 9.518f)
                curveTo(22.051f, 9.458f, 22.381f, 9.39f, 22.898f, 9.341f)
                curveTo(23.366f, 9.298f, 23.981f, 9.267f, 24.712f, 9.247f)
                curveTo(25.526f, 9.225f, 26.279f, 9.22f, 27.225f, 9.221f)
                curveTo(27.22f, 9.221f, 27.305f, 9.221f, 27.326f, 9.221f)
                lineTo(27.407f, 9.221f)
                horizontalLineTo(28.155f)
                curveTo(28.206f, 9.221f, 28.268f, 9.21f, 28.365f, 9.187f)
                curveTo(28.388f, 9.181f, 28.456f, 9.163f, 28.52f, 9.147f)
                curveTo(28.57f, 9.134f, 28.618f, 9.121f, 28.638f, 9.116f)
                curveTo(28.864f, 9.059f, 29.041f, 9.027f, 29.213f, 9.019f)
                curveTo(29.24f, 9.017f, 29.267f, 9.017f, 29.294f, 9.017f)
                curveTo(29.521f, 9.017f, 29.587f, 9.123f, 29.66f, 9.564f)
                curveTo(29.662f, 9.579f, 29.669f, 9.623f, 29.677f, 9.673f)
                curveTo(29.688f, 9.738f, 29.7f, 9.813f, 29.705f, 9.845f)
                curveTo(29.725f, 9.965f, 29.745f, 10.07f, 29.767f, 10.175f)
                curveTo(29.834f, 10.489f, 29.793f, 10.699f, 29.679f, 10.826f)
                curveTo(29.604f, 10.908f, 29.498f, 10.951f, 29.431f, 10.951f)
                curveTo(29.361f, 10.951f, 28.675f, 10.865f, 27.402f, 10.697f)
                curveTo(25.119f, 10.82f, 23.518f, 10.904f, 22.597f, 10.951f)
                curveTo(21.67f, 10.998f, 20.971f, 11.299f, 20.508f, 11.855f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFC221)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(19.507f, 11.399f)
                curveTo(19.507f, 11.399f, 18.779f, 11.866f, 19.046f, 12.18f)
                curveTo(19.313f, 12.494f, 19.34f, 12.533f, 19.393f, 12.533f)
                curveTo(19.393f, 12.533f, 19.407f, 12.198f, 19.494f, 12.198f)
                curveTo(19.58f, 12.198f, 20.263f, 12.524f, 20.51f, 11.972f)
                curveTo(20.758f, 11.421f, 19.507f, 11.399f, 19.507f, 11.399f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFC221)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.922f, 12.921f)
                lineTo(19.598f, 12.611f)
                lineTo(20.24f, 13.306f)
                lineTo(20.426f, 12.684f)
                lineTo(20.886f, 12.797f)
                verticalLineTo(13.111f)
                horizontalLineTo(21.056f)
                verticalLineTo(13.542f)
                lineTo(22.261f, 13.794f)
                lineTo(22.412f, 13.381f)
                curveTo(22.412f, 13.381f, 22.805f, 14.028f, 23.407f, 13.996f)
                curveTo(24.01f, 13.964f, 24.118f, 14.135f, 24.223f, 13.656f)
                curveTo(24.33f, 13.178f, 24.625f, 12.921f, 24.625f, 12.921f)
                lineTo(25.328f, 13.158f)
                curveTo(25.328f, 13.158f, 24.556f, 14.107f, 24.925f, 14.405f)
                lineTo(27.679f, 15.042f)
                lineTo(27.57f, 15.375f)
                horizontalLineTo(27.254f)
                lineTo(27.339f, 15.663f)
                lineTo(24.33f, 15.455f)
                curveTo(24.33f, 15.455f, 23.994f, 15.88f, 23.994f, 15.771f)
                curveTo(23.994f, 15.663f, 23.976f, 15.663f, 23.828f, 15.663f)
                curveTo(23.68f, 15.663f, 23.603f, 15.455f, 23.603f, 15.455f)
                lineTo(23.407f, 15.53f)
                curveTo(23.407f, 15.53f, 23.437f, 15.534f, 23.191f, 15.455f)
                curveTo(22.945f, 15.375f, 22.8f, 15.375f, 22.8f, 15.375f)
                lineTo(21.784f, 15.3f)
                verticalLineTo(15.455f)
                curveTo(21.784f, 15.455f, 21.515f, 15.468f, 21.608f, 15.53f)
                curveTo(21.702f, 15.592f, 23.603f, 15.663f, 23.603f, 15.663f)
                lineTo(23.487f, 15.876f)
                curveTo(23.487f, 15.876f, 24.427f, 15.88f, 24.625f, 15.771f)
                curveTo(24.823f, 15.663f, 24.695f, 16.012f, 24.695f, 16.012f)
                horizontalLineTo(25.629f)
                curveTo(25.629f, 16.012f, 25.398f, 16.231f, 25.101f, 16.231f)
                curveTo(24.804f, 16.231f, 25.953f, 16.595f, 25.953f, 16.595f)
                curveTo(25.953f, 16.595f, 25.312f, 16.794f, 25.014f, 16.663f)
                curveTo(24.718f, 16.531f, 25.141f, 16.917f, 25.328f, 17.015f)
                curveTo(25.516f, 17.112f, 24.668f, 17.104f, 24.33f, 16.727f)
                curveTo(24.33f, 16.727f, 24.436f, 17.006f, 24.33f, 17.086f)
                curveTo(24.33f, 17.086f, 23.737f, 16.387f, 23.441f, 16.387f)
                curveTo(23.145f, 16.387f, 23.487f, 16.848f, 23.487f, 16.848f)
                curveTo(23.487f, 16.848f, 23.318f, 16.607f, 23.129f, 16.705f)
                curveTo(22.94f, 16.803f, 22.8f, 16.913f, 22.8f, 16.913f)
                curveTo(22.8f, 16.913f, 22.677f, 16.487f, 22.022f, 16.31f)
                curveTo(21.368f, 16.134f, 21.587f, 16.069f, 21.056f, 16.012f)
                curveTo(20.525f, 15.955f, 20.499f, 15.663f, 20.426f, 15.663f)
                curveTo(20.353f, 15.663f, 19.791f, 15.171f, 19.791f, 15.171f)
                curveTo(19.791f, 15.171f, 19.666f, 14.71f, 19.959f, 14.71f)
                curveTo(20.252f, 14.71f, 20.716f, 14.573f, 20.886f, 14.71f)
                curveTo(21.056f, 14.848f, 21.128f, 14.71f, 21.128f, 14.71f)
                horizontalLineTo(21.428f)
                lineTo(21.856f, 15.042f)
                horizontalLineTo(22.707f)
                curveTo(22.707f, 15.042f, 22.87f, 14.79f, 23.129f, 14.71f)
                curveTo(23.388f, 14.631f, 23.129f, 14.405f, 23.129f, 14.405f)
                curveTo(23.129f, 14.405f, 22.511f, 14.44f, 22.261f, 14.536f)
                curveTo(22.011f, 14.631f, 22.171f, 14.073f, 22.171f, 14.073f)
                lineTo(21.056f, 13.87f)
                lineTo(20.886f, 14.073f)
                lineTo(20.517f, 14.184f)
                verticalLineTo(14.405f)
                lineTo(20.128f, 14.319f)
                lineTo(20.24f, 13.656f)
                lineTo(19.33f, 14.073f)
                lineTo(17.922f, 12.921f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4D4D4D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(23.522f, 15.813f)
                lineTo(23.603f, 15.663f)
                curveTo(22.447f, 15.62f, 21.792f, 15.579f, 21.638f, 15.541f)
                curveTo(21.624f, 15.537f, 21.614f, 15.534f, 21.608f, 15.53f)
                curveTo(21.515f, 15.468f, 21.784f, 15.455f, 21.784f, 15.455f)
                verticalLineTo(15.36f)
                verticalLineTo(15.3f)
                lineTo(21.849f, 15.305f)
                lineTo(22.8f, 15.375f)
                curveTo(22.897f, 15.375f, 23.027f, 15.402f, 23.191f, 15.455f)
                curveTo(23.26f, 15.477f, 23.314f, 15.495f, 23.35f, 15.507f)
                curveTo(23.353f, 15.502f, 23.357f, 15.496f, 23.364f, 15.486f)
                curveTo(23.381f, 15.475f, 23.389f, 15.47f, 23.396f, 15.469f)
                curveTo(23.401f, 15.467f, 23.407f, 15.467f, 23.416f, 15.467f)
                curveTo(23.416f, 15.467f, 23.412f, 15.531f, 23.407f, 15.53f)
                curveTo(23.407f, 15.53f, 23.542f, 15.477f, 23.544f, 15.477f)
                lineTo(23.603f, 15.455f)
                curveTo(23.627f, 15.519f, 23.655f, 15.568f, 23.689f, 15.602f)
                lineTo(23.702f, 15.615f)
                curveTo(23.739f, 15.647f, 23.781f, 15.663f, 23.828f, 15.663f)
                curveTo(23.976f, 15.663f, 23.994f, 15.663f, 23.994f, 15.771f)
                curveTo(23.994f, 15.844f, 24.106f, 15.738f, 24.33f, 15.455f)
                lineTo(27.339f, 15.663f)
                lineTo(27.254f, 15.439f)
                lineTo(27.267f, 15.421f)
                lineTo(27.254f, 15.375f)
                horizontalLineTo(27.302f)
                lineTo(27.316f, 15.358f)
                lineTo(27.321f, 15.375f)
                horizontalLineTo(27.57f)
                lineTo(27.679f, 15.042f)
                lineTo(24.925f, 14.405f)
                curveTo(24.679f, 14.206f, 24.813f, 13.79f, 25.328f, 13.158f)
                lineTo(24.625f, 12.921f)
                curveTo(24.428f, 13.092f, 24.294f, 13.337f, 24.223f, 13.656f)
                curveTo(24.145f, 14.012f, 24.065f, 14.009f, 23.781f, 13.997f)
                curveTo(23.684f, 13.993f, 23.562f, 13.988f, 23.407f, 13.996f)
                curveTo(23.006f, 14.018f, 22.674f, 13.813f, 22.412f, 13.381f)
                lineTo(22.261f, 13.794f)
                lineTo(21.056f, 13.542f)
                verticalLineTo(13.111f)
                horizontalLineTo(20.886f)
                verticalLineTo(12.797f)
                lineTo(20.426f, 12.684f)
                lineTo(20.262f, 13.235f)
                lineTo(20.288f, 13.263f)
                lineTo(20.25f, 13.272f)
                lineTo(20.24f, 13.306f)
                lineTo(20.216f, 13.28f)
                lineTo(20.178f, 13.288f)
                lineTo(20.189f, 13.251f)
                lineTo(19.598f, 12.611f)
                lineTo(17.922f, 12.921f)
                lineTo(19.33f, 14.073f)
                lineTo(20.169f, 13.689f)
                lineTo(20.176f, 13.646f)
                lineTo(20.209f, 13.67f)
                lineTo(20.24f, 13.656f)
                lineTo(20.235f, 13.689f)
                lineTo(20.267f, 13.714f)
                lineTo(20.227f, 13.732f)
                lineTo(20.128f, 14.319f)
                lineTo(20.517f, 14.405f)
                verticalLineTo(14.184f)
                lineTo(20.886f, 14.073f)
                lineTo(21.056f, 13.87f)
                curveTo(21.056f, 13.87f, 22.109f, 14.057f, 22.113f, 14.062f)
                lineTo(22.171f, 14.073f)
                curveTo(22.166f, 14.092f, 22.161f, 14.111f, 22.154f, 14.134f)
                curveTo(22.068f, 14.462f, 22.104f, 14.596f, 22.261f, 14.536f)
                curveTo(22.428f, 14.472f, 22.717f, 14.428f, 23.129f, 14.405f)
                curveTo(23.302f, 14.555f, 23.302f, 14.657f, 23.129f, 14.71f)
                curveTo(22.957f, 14.764f, 22.816f, 14.874f, 22.707f, 15.042f)
                horizontalLineTo(21.856f)
                lineTo(21.428f, 14.71f)
                horizontalLineTo(21.128f)
                curveTo(21.08f, 14.802f, 21f, 14.802f, 20.886f, 14.71f)
                curveTo(20.772f, 14.618f, 20.524f, 14.65f, 20.285f, 14.681f)
                curveTo(20.169f, 14.696f, 20.055f, 14.71f, 19.959f, 14.71f)
                curveTo(19.764f, 14.71f, 19.708f, 14.864f, 19.791f, 15.171f)
                curveTo(20.166f, 15.499f, 20.377f, 15.663f, 20.426f, 15.663f)
                curveTo(20.446f, 15.663f, 20.463f, 15.685f, 20.488f, 15.719f)
                curveTo(20.553f, 15.807f, 20.673f, 15.97f, 21.056f, 16.012f)
                curveTo(21.344f, 16.043f, 21.412f, 16.076f, 21.517f, 16.128f)
                curveTo(21.606f, 16.172f, 21.722f, 16.229f, 22.022f, 16.31f)
                curveTo(22.458f, 16.428f, 22.718f, 16.629f, 22.8f, 16.913f)
                curveTo(22.8f, 16.913f, 22.94f, 16.803f, 23.129f, 16.705f)
                curveTo(23.251f, 16.642f, 23.367f, 16.684f, 23.477f, 16.833f)
                curveTo(23.497f, 16.863f, 23.51f, 16.879f, 23.51f, 16.879f)
                curveTo(23.499f, 16.864f, 23.488f, 16.848f, 23.477f, 16.833f)
                curveTo(23.421f, 16.755f, 23.176f, 16.387f, 23.441f, 16.387f)
                curveTo(23.638f, 16.387f, 23.935f, 16.62f, 24.33f, 17.086f)
                curveTo(24.383f, 17.046f, 24.396f, 16.968f, 24.369f, 16.852f)
                curveTo(24.337f, 16.826f, 24.308f, 16.799f, 24.281f, 16.77f)
                curveTo(24.281f, 16.77f, 24.331f, 16.731f, 24.338f, 16.736f)
                lineTo(24.39f, 16.705f)
                curveTo(24.405f, 16.744f, 24.417f, 16.781f, 24.427f, 16.816f)
                curveTo(24.806f, 17.104f, 25.5f, 17.104f, 25.328f, 17.015f)
                curveTo(25.216f, 16.957f, 25.021f, 16.796f, 24.939f, 16.698f)
                curveTo(24.898f, 16.646f, 24.898f, 16.619f, 24.984f, 16.65f)
                curveTo(24.993f, 16.653f, 25.003f, 16.658f, 25.014f, 16.663f)
                curveTo(25.213f, 16.75f, 25.525f, 16.728f, 25.953f, 16.595f)
                curveTo(25.507f, 16.454f, 25.225f, 16.354f, 25.088f, 16.286f)
                curveTo(25.02f, 16.249f, 25.024f, 16.231f, 25.103f, 16.231f)
                curveTo(25.101f, 16.226f, 25.099f, 16.221f, 25.095f, 16.215f)
                curveTo(25.099f, 16.218f, 25.105f, 16.222f, 25.121f, 16.231f)
                curveTo(25.259f, 16.227f, 25.386f, 16.188f, 25.503f, 16.112f)
                horizontalLineTo(25.555f)
                curveTo(25.573f, 16.089f, 25.592f, 16.065f, 25.61f, 16.039f)
                lineTo(25.608f, 16.031f)
                curveTo(25.615f, 16.025f, 25.622f, 16.018f, 25.629f, 16.012f)
                horizontalLineTo(25.603f)
                lineTo(25.608f, 16.031f)
                curveTo(25.574f, 16.061f, 25.539f, 16.088f, 25.503f, 16.112f)
                horizontalLineTo(25.44f)
                curveTo(25.472f, 16.083f, 25.502f, 16.049f, 25.532f, 16.012f)
                horizontalLineTo(24.764f)
                lineTo(24.756f, 16.033f)
                lineTo(24.741f, 16.012f)
                horizontalLineTo(24.695f)
                curveTo(24.701f, 15.997f, 24.706f, 15.983f, 24.71f, 15.969f)
                lineTo(24.717f, 15.948f)
                curveTo(24.775f, 15.765f, 24.744f, 15.706f, 24.625f, 15.771f)
                curveTo(24.498f, 15.841f, 24.144f, 15.876f, 23.56f, 15.877f)
                lineTo(23.544f, 15.906f)
                lineTo(23.526f, 15.877f)
                lineTo(23.487f, 15.876f)
                lineTo(23.506f, 15.843f)
                lineTo(23.487f, 15.813f)
                lineTo(23.522f, 15.813f)
                close()
                moveTo(19.34f, 13.998f)
                lineTo(18.069f, 12.958f)
                lineTo(19.574f, 12.68f)
                lineTo(20.27f, 13.433f)
                lineTo(20.47f, 12.76f)
                lineTo(20.822f, 12.846f)
                verticalLineTo(13.175f)
                horizontalLineTo(20.992f)
                verticalLineTo(13.594f)
                lineTo(22.303f, 13.868f)
                lineTo(22.429f, 13.524f)
                curveTo(22.691f, 13.9f, 23.02f, 14.081f, 23.411f, 14.06f)
                curveTo(23.528f, 14.053f, 23.621f, 14.054f, 23.758f, 14.06f)
                curveTo(23.984f, 14.069f, 24.034f, 14.066f, 24.108f, 14.022f)
                curveTo(24.195f, 13.969f, 24.242f, 13.87f, 24.287f, 13.67f)
                curveTo(24.351f, 13.379f, 24.469f, 13.154f, 24.64f, 12.993f)
                lineTo(25.221f, 13.189f)
                curveTo(24.732f, 13.808f, 24.608f, 14.231f, 24.896f, 14.463f)
                lineTo(27.596f, 15.088f)
                lineTo(27.523f, 15.312f)
                horizontalLineTo(27.168f)
                lineTo(27.251f, 15.593f)
                lineTo(24.3f, 15.389f)
                lineTo(24.279f, 15.416f)
                curveTo(24.18f, 15.541f, 24.103f, 15.631f, 24.05f, 15.684f)
                curveTo(24.03f, 15.613f, 23.971f, 15.599f, 23.828f, 15.599f)
                curveTo(23.761f, 15.599f, 23.707f, 15.549f, 23.664f, 15.433f)
                lineTo(23.641f, 15.372f)
                curveTo(23.641f, 15.372f, 23.397f, 15.456f, 23.39f, 15.453f)
                curveTo(23.353f, 15.441f, 23.293f, 15.421f, 23.211f, 15.394f)
                curveTo(23.042f, 15.34f, 22.907f, 15.312f, 22.803f, 15.312f)
                lineTo(21.719f, 15.232f)
                verticalLineTo(15.396f)
                curveTo(21.705f, 15.398f, 21.69f, 15.4f, 21.676f, 15.402f)
                curveTo(21.63f, 15.409f, 21.595f, 15.418f, 21.569f, 15.434f)
                curveTo(21.506f, 15.47f, 21.51f, 15.542f, 21.572f, 15.583f)
                curveTo(21.649f, 15.634f, 22.25f, 15.675f, 23.497f, 15.722f)
                lineTo(23.38f, 15.94f)
                lineTo(23.487f, 15.94f)
                curveTo(24.127f, 15.942f, 24.511f, 15.907f, 24.656f, 15.827f)
                curveTo(24.666f, 15.822f, 24.674f, 15.818f, 24.681f, 15.815f)
                curveTo(24.68f, 15.825f, 24.678f, 15.838f, 24.675f, 15.854f)
                curveTo(24.668f, 15.889f, 24.655f, 15.935f, 24.635f, 15.99f)
                lineTo(24.604f, 16.075f)
                horizontalLineTo(25.44f)
                curveTo(25.336f, 16.137f, 25.223f, 16.167f, 25.101f, 16.167f)
                curveTo(25.068f, 16.167f, 25.045f, 16.17f, 25.025f, 16.177f)
                curveTo(24.979f, 16.196f, 24.959f, 16.247f, 24.99f, 16.29f)
                curveTo(25.01f, 16.319f, 25.056f, 16.344f, 25.14f, 16.38f)
                curveTo(25.257f, 16.431f, 25.454f, 16.501f, 25.732f, 16.591f)
                curveTo(25.421f, 16.667f, 25.19f, 16.671f, 25.041f, 16.605f)
                curveTo(24.999f, 16.586f, 24.968f, 16.576f, 24.942f, 16.573f)
                curveTo(24.892f, 16.567f, 24.845f, 16.594f, 24.847f, 16.651f)
                curveTo(24.849f, 16.693f, 24.881f, 16.735f, 24.944f, 16.798f)
                curveTo(25.011f, 16.866f, 25.105f, 16.944f, 25.188f, 17.002f)
                curveTo(25.143f, 17f, 25.091f, 16.995f, 25.037f, 16.986f)
                curveTo(24.765f, 16.942f, 24.515f, 16.837f, 24.378f, 16.685f)
                lineTo(24.146f, 16.427f)
                lineTo(24.269f, 16.75f)
                curveTo(24.308f, 16.851f, 24.322f, 16.925f, 24.318f, 16.973f)
                curveTo(23.941f, 16.541f, 23.654f, 16.324f, 23.441f, 16.324f)
                curveTo(23.343f, 16.324f, 23.277f, 16.367f, 23.26f, 16.446f)
                curveTo(23.249f, 16.495f, 23.258f, 16.552f, 23.283f, 16.617f)
                curveTo(23.223f, 16.606f, 23.162f, 16.616f, 23.099f, 16.649f)
                curveTo(23.079f, 16.659f, 23.059f, 16.669f, 23.04f, 16.68f)
                curveTo(22.968f, 16.72f, 22.901f, 16.763f, 22.832f, 16.811f)
                curveTo(22.719f, 16.547f, 22.452f, 16.36f, 22.039f, 16.249f)
                curveTo(21.883f, 16.207f, 21.769f, 16.169f, 21.677f, 16.131f)
                curveTo(21.643f, 16.117f, 21.612f, 16.104f, 21.579f, 16.087f)
                lineTo(21.567f, 16.081f)
                curveTo(21.548f, 16.072f, 21.512f, 16.055f, 21.5f, 16.049f)
                curveTo(21.391f, 15.998f, 21.289f, 15.973f, 21.063f, 15.948f)
                curveTo(20.867f, 15.927f, 20.734f, 15.873f, 20.64f, 15.794f)
                curveTo(20.614f, 15.772f, 20.574f, 15.724f, 20.54f, 15.683f)
                lineTo(20.54f, 15.683f)
                curveTo(20.512f, 15.65f, 20.488f, 15.622f, 20.479f, 15.616f)
                curveTo(20.465f, 15.606f, 20.449f, 15.6f, 20.427f, 15.597f)
                curveTo(20.419f, 15.594f, 20.408f, 15.587f, 20.393f, 15.578f)
                curveTo(20.363f, 15.559f, 20.322f, 15.53f, 20.271f, 15.49f)
                curveTo(20.169f, 15.411f, 20.028f, 15.293f, 19.849f, 15.137f)
                curveTo(19.781f, 14.877f, 19.822f, 14.774f, 19.959f, 14.774f)
                curveTo(20.044f, 14.774f, 20.116f, 14.767f, 20.3f, 14.743f)
                lineTo(20.337f, 14.738f)
                curveTo(20.633f, 14.7f, 20.775f, 14.703f, 20.845f, 14.759f)
                curveTo(20.973f, 14.863f, 21.091f, 14.873f, 21.164f, 14.774f)
                horizontalLineTo(21.405f)
                lineTo(21.834f, 15.106f)
                horizontalLineTo(22.743f)
                lineTo(22.762f, 15.076f)
                curveTo(22.862f, 14.92f, 22.991f, 14.82f, 23.149f, 14.771f)
                curveTo(23.378f, 14.7f, 23.378f, 14.536f, 23.172f, 14.357f)
                lineTo(23.125f, 14.341f)
                curveTo(22.707f, 14.365f, 22.413f, 14.41f, 22.238f, 14.476f)
                curveTo(22.19f, 14.495f, 22.184f, 14.492f, 22.177f, 14.456f)
                curveTo(22.165f, 14.391f, 22.183f, 14.267f, 22.234f, 14.09f)
                lineTo(22.253f, 14.023f)
                lineTo(21.031f, 13.801f)
                lineTo(20.849f, 14.017f)
                lineTo(20.453f, 14.136f)
                verticalLineTo(14.325f)
                lineTo(20.202f, 14.27f)
                lineTo(20.324f, 13.548f)
                lineTo(19.34f, 13.998f)
                close()
                moveTo(23.407f, 15.532f)
                curveTo(23.417f, 15.533f, 23.42f, 15.533f, 23.415f, 15.529f)
                lineTo(23.407f, 15.532f)
                close()
                moveTo(21.636f, 15.543f)
                lineTo(21.636f, 15.543f)
                lineTo(21.637f, 15.542f)
                lineTo(21.636f, 15.543f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun AmericanSamoaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.AmericanSamoa,
            contentDescription = "American Samoa Flag"
        )
    }
}
